import {
  Button,
  Form,
  Input,
  Pagination,
  Select,
  Skeleton,
  Steps
} from "antd";
import { StatusCode } from "common/enums";
import { useWindowSize } from "hooks/useWindowSize.hook";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as TEACHER_SERVICES from "../../../api/services/teacher/teacher.services";
import * as TOPICS_SERVICES from "../../../api/services/topics/topics.services";

//!COMPONENTS
import Breadcrumbs from "components/breadcrumbs";
import CardAdsTeacher from "./components";

//!IMAGES

//!STYLES
import AppResult from "components/appResults";
import { useLocation } from "react-router-dom";
import { setUserConnect } from "store/auth/authSlice";
import { useGetAllLevelsQuery } from "store/services/app/levels.services";
/* import Pagination from "../../../components/pagination/index"; */
import s from "../../student/searchTeacher/assets/searchTeacher.module.css";

import TeacherIcon from "../../../assets/images/app/iam_teacher.svg";
import SearchIcon from "../../../assets/images/app/search.svg";

const { Option } = Select;
const { Step } = Steps;
const { Search } = Input;

const OrganismTeachers: FC = () => {

  //!HOOKS
  const dispatch = useDispatch();
  const { user, isLoggedIn } = useSelector((state) => state.auth);
  const topics = useSelector((state) => state.topics);
  const { data: levelsData } = useGetAllLevelsQuery();
  const size = useWindowSize();
  const location = useLocation();
  // State to hold the input value
  const [inputValue, setInputValue] = useState('');
  const [formInfos] = Form.useForm();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [organismTeachers, setOrganismTeachers] = useState<any>();
  const [filteredOrganismTeachers, setFilteredOrganismTeachers] = useState<any>();

  //!STATE
  const [openDrawerInstaProf, setOpenDrawerInstaProf] =
    useState<boolean>(false);
  const [tempTopic, setTempTopic] = useState<any>();
  const refSubmiteBtn = useRef<any>(null);
  const [top, setTop] = useState(10);
  const [showDrawerCreProf, setShowDrawerCreProf] = useState<boolean>(false);
  const [displayFilter, setDisplayFilter] = useState<boolean>(false);
  const [isBtnInstaProf, setIsBtnInstaProf] = useState<boolean>(false);
  const [idTeacher, setIdTeacher] = useState<any>(null);
  const searchParams = new URLSearchParams(location.search);
  const inputParams = searchParams.get('s');

  const [selectedLevel, setSelectedLevel] = useState<string>();
  const [selectedTopic, setSelectedTopic] = useState<string>();
  const [teacherName, setTeacherName] = useState<string>();

  const [teachersAdded, setTeachersAdded] = useState(user?.listProfs);

  const pageSize = 9;

  /* const handleSelectChange = (value: string) => {
    if (value !== undefined) {
      const [minValue, maxValue] = value.split('-');
      const minField = 'minTarif';
      const maxField = 'maxTarif';
      if (maxValue === 'plus') {
        formInfos.setFieldsValue({
          [minField]: parseInt(minValue)
        });
        formInfos.setFieldsValue({
          ['maxTarif']: undefined
        });
      } else {
        formInfos.setFieldsValue({
          [minField]: parseInt(minValue),
          [maxField]: parseInt(maxValue)
        });
      }

      formInfos.setFieldsValue({
        ['tarif']: undefined
      });
      setCurrentPage(1);
      onSubmit();
    }
  }; */

  const onShowDrawerCalendarProf = () => {
    if (isLoggedIn) {
      setShowDrawerCreProf(true);
    } else {
      dispatch(setUserConnect(true));
    }
  };

  const showDrawerSearchInstaProf = () => {
    if (isLoggedIn) {
      setOpenDrawerInstaProf(!openDrawerInstaProf);
    } else {
      dispatch(setUserConnect(true));
    }
  };

  const searchTeacher = async () => {
    try {
      setIsLoading(true);
      const response = await TEACHER_SERVICES.fetchOrganismTeachers(user?._id);
      if (response?.statusCode === StatusCode.OK) {
        setOrganismTeachers(response?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const OnSelectLevel = useCallback(
    async (levelId: string) => {
      setSelectedLevel(levelId);
      const response = await TOPICS_SERVICES.findAll(levelId);
      if (response?.statusCode === StatusCode.OK) {
        setTempTopic(response?.data);
      }
    },
    [tempTopic]
  );

  const handleInputChange = (e: any) => {
    setInputValue(e.target.value);
  };

  const onSubmit = () => {
    refSubmiteBtn?.current?.click();
  };

  const handleSubmit = (e: any) => {
    handleInputChange(e);
    onSubmit();
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const paginatedTeachers = filteredOrganismTeachers?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  useEffect(() => {
    if (size.width > 700) {
      setDisplayFilter(true);
    }
  }, [displayFilter, size.width]);

  useEffect(() => {
    if (user) {
      searchTeacher();
    }
  }, [user]);

  const levels = levelsData?.data;

  /* useEffect(() => {
    formInfos.setFieldsValue({ page: currentPage });
    onSubmit();
  }, [currentPage]); */

  useEffect(() => {
    if (organismTeachers) {
      setFilteredOrganismTeachers(organismTeachers?.results);
    }
  }, [organismTeachers]);

  useEffect(() => {
    if (!organismTeachers?.results) return;

    setIsLoading(true);

    let filtered = [...organismTeachers.results];

    if (selectedLevel) {
      filtered = filtered.filter((teacher: any) =>
        teacher?.nivMat?.some(
          (niv: any) => niv?.niveau?._id === selectedLevel
        )
      );
    }

    if (selectedLevel && selectedTopic) {
      filtered = filtered.filter((teacher: any) =>
        teacher?.nivMat?.some(
          (niv: any) =>
            niv?.niveau?._id === selectedLevel &&
            niv?.matieres?.some(
              (m: any) => m?.matiere === selectedTopic
            )
        )
      );
    }

    if (teacherName && teacherName.length >= 3) {
      filtered = filtered.filter((teacher: any) =>
        teacher?.firstname.toLowerCase().includes(teacherName.toLowerCase()) || teacher?.lastname.toLowerCase().includes(teacherName.toLowerCase())
      );
    }

    setFilteredOrganismTeachers(filtered);
    setIsLoading(false);
  }, [selectedLevel, selectedTopic, teacherName, organismTeachers]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredOrganismTeachers]);


  return (
    <React.Fragment>
      <Breadcrumbs isSearchProf={true} />
      <div style={{ maxWidth: "1250px", margin: isMobile ? "20px auto" : "0px auto", padding: isMobile ? "0 4%" : "0 2%" }}>
        {isLoading ? <Skeleton active /> : <div className={s.headerBox}>
          <div className={s.titleBox}>
            <div className={s.titlePictureBox}>
              <img src={TeacherIcon} height={isMobile ? 18 : 65}></img>
            </div>
            Mes profs
          </div>
        </div>}

        {isLoading ? <Skeleton active /> : <Form
          layout="inline"
          name="searchTeacher"
          autoComplete="off"
          form={formInfos}
          initialValues={{ search: inputParams, page: currentPage }}
          onFinish={searchTeacher}
        >
          <Button
            htmlType="submit"
            ref={refSubmiteBtn}
            style={{ position: "absolute", left: "-100%" }}
          >
            Go
          </Button>
          <div className={s.searchBox}>
            <div className={s.selectBox}>
              <span style={{ color: "#393E3E", opacity: "0.3", fontSize: isMobile ? "0.75em" : "14px" }}>Choisis ton niveau</span>
              <Form.Item name="level">
                <Select
                  placeholder={<span style={{ color: "#000", opacity: "0.8", fontSize: isMobile ? "0.75em" : "12px" }}>Niveau</span>}
                  allowClear={true}
                  bordered={false}
                  style={{ width: isMobile ? "75vw" : "205px", position: "relative", left: "-12px", top: isMobile ? "-12px" : "0px", fontSize: isMobile ? "0.8em" : "12px" }}
                  onChange={(value: string) => {
                    OnSelectLevel(value);
                  }}
                >
                  {Object.keys(levels || {}).map((levelGroup) =>
                    levels[levelGroup]?.map((level: any) => (
                      <Option key={level._id} value={level._id}>
                        {level.title}
                      </Option>
                    ))
                  )}
                </Select>
              </Form.Item>
            </div>

            <div className={s.separation}></div>

            <div className={s.selectBox}>
              <span style={{ color: "#393E3E", opacity: "0.3", fontSize: isMobile ? "0.75em" : "14px" }}>Choisis ta matière</span>
              <Form.Item name="matiere">
                <Select
                  placeholder={<span style={{ color: "#000", opacity: "0.8", fontSize: isMobile ? "0.75em" : "12px" }}>Matière</span>}
                  allowClear={true}
                  bordered={false}
                  style={{ width: isMobile ? "75vw" : "205px", position: "relative", left: "-12px", top: isMobile ? "-12px" : "0px", fontSize: isMobile ? "0.8em" : "12px" }}
                  onChange={(value: string) => { /* setCurrentPage(1);  */setSelectedTopic(value); }}
                >
                  {tempTopic?.map((topic: any) => (
                    <Option key={topic._id} value={topic._id}>
                      {topic.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className={s.separation}></div>

            <div className={s.selectBox} style={{ visibility: "hidden" }}>
              <span style={{ color: "#393E3E", opacity: "0.3", fontSize: isMobile ? "0.75em" : "14px" }}>Choisis ton tarif</span>
              <Form.Item name="tarif">
                <Select
                  placeholder={<span style={{ color: "#000", opacity: "0.8", fontSize: isMobile ? "0.75em" : "12px" }}>Tarifs</span>}
                  allowClear
                  bordered={false}
                  style={{ width: isMobile ? "75vw" : "205px", position: "relative", left: "-12px", top: isMobile ? "-12px" : "0px", fontSize: isMobile ? "0.8em" : "12px" }}
                /* onChange={handleSelectChange} */
                >
                  <Option value={"1-15"}>1 - 15 €</Option>
                  <Option value={"15-30"}>15 - 30 €</Option>
                  <Option value={"30-50"}>30 - 50 €</Option>
                  <Option value={"50-100"}>50 - 100 €</Option>
                  <Option value={"100-plus"}>100 et plus</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={`${s.select}`} style={{ visibility: "hidden", width: "1px" }}>
              <Form.Item name="minTarif">
                <Select
                  placeholder="Tarif min "
                  allowClear
                  bordered={false}
                >
                  <Option value={0}>0</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={`${s.select}`} style={{ visibility: "hidden", width: "1px" }}>
              <Form.Item name="maxTarif">
                <Select
                  placeholder="Tarif max "
                  allowClear
                  bordered={false}
                >
                  <Option value={0}>0</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={s.inputBox}>
              <div className={s.filedSearch}>
                <Form.Item name="search">
                  <Input
                    className={s.searchInput}
                    placeholder="Chercher un prof"
                    bordered={false}
                    style={{ textAlign: "left", paddingTop: isMobile ? "3px" : "12px", paddingLeft: isMobile ? "10px" : "30px", paddingRight: isMobile ? "10px" : "30px" }}
                    onChange={(e) => { /* setCurrentPage(1);  */setTeacherName(e?.target?.value); }}
                  />
                </Form.Item>
              </div>
              {isMobile && <div style={{ width: "10%" }}>
                <Form.Item>
                  <Button
                    ref={refSubmiteBtn}
                    shape="circle"
                    htmlType="submit"
                    style={{ background: "#8AB0B1", height: "30px", width: "30px" }}
                  >
                    <img src={SearchIcon} height={10} style={{ filter: 'brightness(0) invert(1)' }}></img>
                  </Button>
                </Form.Item>
              </div>}
            </div>
            {!isMobile && <Form.Item>
              <Button
                ref={refSubmiteBtn}
                shape="circle"
                htmlType="submit"
                style={{ background: "#8AB0B1", height: "45px", width: "45px" }}
              >
                <img src={SearchIcon} height={15} style={{ filter: 'brightness(0) invert(1)' }}></img>
              </Button>
            </Form.Item>}
            <Form.Item name="page" hidden><Input value={currentPage}></Input></Form.Item>
            {isLoggedIn && <Form.Item name="userId" initialValue={user?._id} hidden></Form.Item>}
          </div>
        </Form>}

        <div className={s.main}>
          {isLoading && (
            <>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </>
          )}

          {!isLoading && filteredOrganismTeachers?.length > 0 ? (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  gap: "24px",
                  height: "auto",
                  overflow: "visible",
                }}
              >
                {paginatedTeachers.map((teacher: any) => (
                  <div key={teacher?._id} onClick={() => setIdTeacher(teacher)}>
                    <CardAdsTeacher
                      handleDisplayTeacher={() => null}
                      resetDrawerInstaProf={() => null}
                      handleOpenDrwerProfileTeacher={() => null}
                      onShowDrawerCalendarProf={onShowDrawerCalendarProf}
                      teacher={teacher}
                      isBtnInstaProf={isBtnInstaProf}
                      setIsBtnInstaProf={setIsBtnInstaProf}
                      showDrawerSearchInstaProf={showDrawerSearchInstaProf}
                      teacherAdded={teachersAdded.includes(teacher?._id)}
                    />
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={filteredOrganismTeachers.length}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger={false} // disable changing page size
                />
              </div>
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <AppResult status="info" title="Aucun professeur trouvé" />
            </div>
          )}
        </div>

      </div>

      <div style={{ height: "100px", width: "100%" }}></div>

      {/* {!isLoading && organismTeachers?.data?.result.length > 0 && (
        <Pagination
          setCurrentPage={setCurrentPage}
          totalPages={organismTeachers?.data?.totalPages}
          currentPage={currentPage}
        />
      )} */}
    </React.Fragment>
  );
};

export default OrganismTeachers;
